exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".features-title {\n  font-size: 18px;\n  line-height: 22px;\n  font-weight: bold;\n  color: #333;\n  text-align: left;\n  background: white;\n  padding: 0px;\n  margin: 4px 0px 25px 0px; }\n\n.features-heading {\n  font-size: 14px;\n  line-height: 16px;\n  font-weight: bold;\n  text-align: left;\n  background: white;\n  padding: 0px;\n  margin: 0px 0px 0px 0px; }\n\n.features-text {\n  font-size: 12px;\n  color: #555;\n  line-height: 14px;\n  text-align: left;\n  background: white;\n  padding: 0px;\n  margin: 5px 25px 5px 0px; }\n\n.features-divide {\n  margin: 25px 0; }\n\n#last.features-divide {\n  color: #ff0000; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/features/features.component.scss
// module id = ../../../../../src/app/features/features.component.scss
// module chunks = 1